import essApi from "../axios/essApi";

class ProfessionalService {

    async getProfessional() {
        return Promise.resolve(essApi.get(`user-professional`));
    }

    async getProfessionalById(reqBody) {
      return Promise.resolve(essApi.get(`/user-professional-by-user-id/${reqBody}`));
  }
    async addProfessional(reqBody) {
        return Promise.resolve(essApi.post(`user-professional`, reqBody));
    }
    async updateProfessional(reqBody) {
        return Promise.resolve(essApi.put(`user-professional/${reqBody.id}`, reqBody));
    }
    async deleteProfessional(id) {
        return Promise.resolve(essApi.delete(`user-professional/${id}`));
    }

    async getUserProfileDetails(id) {
        return Promise.resolve(essApi.get(`users/getDetails/${id}`));
    }
}

export default ProfessionalService;
